import request from "@/utils/request";
import { getAuthorizationHeader } from ".";

export async function create(order) {
  const response = await request.post(
    "/orders",
    order,
    getAuthorizationHeader()
  );
  return response.data.data;
}

export async function own(id) {
  await request.patch(`/orders/${id}/own`, null, getAuthorizationHeader());
}

export async function getById(id) {
  const response = await request.get(`/orders/${id}`, getAuthorizationHeader());
  return response.data.data;
}

export async function getMine({ page, size }) {
  const response = await request.get(
    `/orders/me?page=${page}&size=${size}`,
    getAuthorizationHeader()
  );
  return response.data.data;
}

export async function addLineItems(id, shoppingCartId) {
  await request.patch(
    `/orders/${id}/line-items`,
    { shoppingCartId },
    getAuthorizationHeader()
  );
}

export async function getOrderDetailLink(orderNumber) {
  const response = await request.get(`/orders/order-detail-url/${orderNumber}`);
  return response.data.data;
}
